import { rulesMessages } from '@/consts/error-messages'

export const requiredRule = {
  required: true,
  trigger: ['change', 'blur'],
  message: rulesMessages.required
}
